<div class="bg-white h-full">
    <!-- Header -->
    <div class="px-4 py-3 pb-0">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
                <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                    <i class="fa-solid fa-arrow-up-right-from-square text-blue-600 text-sm"></i>
                </div>
                <h2 class="text-sm font-semibold text-gray-900">{{ 'OPEN_OTHER_PROFILE_MODAL.TITLE' | translate }}</h2>
            </div>
            <button (click)="close()"
                    class="p-1.5 hover:bg-gray-100 rounded-lg transition-colors">
                <i class="fa-solid fa-xmark text-gray-500 text-sm"></i>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="px-4 py-3">
        <p class="text-[13px] text-gray-600">
            {{ 'OPEN_OTHER_PROFILE_MODAL.SUBTITLE' | translate }}
        </p>

        <!-- Why box -->
        <div class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
            <div class="flex items-start gap-2">
                <i class="fa-solid fa-circle-info text-blue-500 mt-0.5"></i>
                <div>
                    <p class="text-xs font-semibold text-blue-800">{{ 'OPEN_OTHER_PROFILE_MODAL.WHY_TITLE' | translate }}</p>
                    <p class="text-xs text-blue-700 mt-1">{{ 'OPEN_OTHER_PROFILE_MODAL.WHY_DESCRIPTION' | translate }}</p>
                </div>
            </div>
        </div>

        <!-- How steps -->
        <div class="mt-4">
            <p class="text-xs font-semibold text-gray-800 mb-2">{{ 'OPEN_OTHER_PROFILE_MODAL.HOW_TITLE' | translate }}</p>
            <div class="space-y-2">
                <div class="flex items-start gap-2.5">
                    <span class="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[11px] font-bold text-gray-600 shrink-0">1</span>
                    <span class="text-xs text-gray-600 pt-0.5">{{ 'OPEN_OTHER_PROFILE_MODAL.STEP_1' | translate }}</span>
                </div>
                <div class="flex items-start gap-2.5">
                    <span class="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[11px] font-bold text-gray-600 shrink-0">2</span>
                    <span class="text-xs text-gray-600 pt-0.5">{{ 'OPEN_OTHER_PROFILE_MODAL.STEP_2' | translate }}</span>
                </div>
                <div class="flex items-start gap-2.5">
                    <span class="w-5 h-5 rounded-full bg-gray-200 flex items-center justify-center text-[11px] font-bold text-gray-600 shrink-0">3</span>
                    <span class="text-xs text-gray-600 pt-0.5">{{ 'OPEN_OTHER_PROFILE_MODAL.STEP_3' | translate }}</span>
                </div>
            </div>
        </div>

        <!-- Copy button -->
        <button (click)="copyLink()"
                class="mt-4 w-full h-9 rounded-md text-white text-[13px] font-medium transition-colors flex items-center justify-center gap-2"
                [ngClass]="copied ? 'bg-green-600' : 'bg-primary hover:bg-primary/90'">
            <i class="fa-solid text-xs" [ngClass]="copied ? 'fa-check' : 'fa-link'"></i>
            {{ (copied ? 'OPEN_OTHER_PROFILE_MODAL.COPIED' : 'OPEN_OTHER_PROFILE_MODAL.COPY_LINK') | translate }}
        </button>
    </div>

    <!-- Footer -->
    <div class="px-4 py-3">
        <div class="flex justify-end">
            <button (click)="close()"
                    type="button"
                    class="h-8 px-4 rounded-md bg-white text-gray-700 text-[13px] transition-colors border border-gray-300 hover:bg-gray-50">
                {{ 'OPEN_OTHER_PROFILE_MODAL.CLOSE' | translate }}
            </button>
        </div>
    </div>
</div>
